import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function collapseGroup({ component, key } = {}) {
  let data = component.props.pageComponent.state.assessmentChecklistTemplateGroupList.map((group, i) => {
    if (group.key === key) {
      if (group.Collapsed !== true) {
        group.Collapsed = true;
      } else {
        group.Collapsed = false;
      }
    }
    return group;
  });
  component.setState({ assessmentChecklistTemplateGroupList: data });
}

export function addAssessmentChecklistTemplate({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    // sectionComponent.customForm.current?.getComponentDataSource();

    //设置默认选择的Folder和Group
    let formData = parameter;
    //设置富文本的控件为空字符串，否则会崩
    formData['Comments'] = '';
    formData['Note'] = '';
    formData['Guideline'] = '';
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });

    setTimeout(() => {
      if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'] !== undefined) {
        if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'].filter(c => c.Key == 'Compliance Assessment').length > 0) {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'].filter(c => c.Key == 'Compliance Assessment')[0].Value);
        } else {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'][0].Value);
        }
      }
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function refreshData({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.getAssessmentChecklistTemplateFolderData(pageComponent.state.assessmentChecklistTemplateFolderData.AssessmentChecklistTemplateFolderId);
}

export function deleteAssessmentChecklistTemplateRun({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.getAssessmentChecklistTemplateFolderData(pageComponent.state.assessmentChecklistTemplateFolderData.AssessmentChecklistTemplateFolderId);
}

export function getChecklistStatusSetIdDataSourceRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setTimeout(() => {
    if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'] !== undefined) {
      if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'].filter(c => c.Key == 'Compliance Assessment').length > 0) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'].filter(c => c.Key == 'Compliance Assessment')[0].Value);
      } else {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'][0].Value);
      }
    }
  }, config.setTimeoutMilliSecond);
}

export function editAssessmentChecklistTemplatePopUpRun({ parameter, sectionComponent, formComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({activeKey: 0, assessmentChecklistTemplateId: parameter.key, assessmentChecklistTemplateCommentOptionList: [], assessmentChecklistTemplateNoteOptionList: [] });
  sectionComponent.getAssessmentChecklistTemplateCommentOptionList(parameter.key);
  sectionComponent.getAssessmentChecklistTemplateNoteOptionList(parameter.key);
  sectionComponent.getAssessmentChecklistTemplateRequirementOptionList(parameter.key);
}

